/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentTypeEnum } from './assessmentTypeEnum';


export interface CreateOrderApiModel { 
    type: AssessmentTypeEnum;
    employeeId: number;
    providerId?: number | null;
    externalPlannedDate?: string | null;
    contractId?: number | null;
    capabilityIds: Array<number>;
}
export namespace CreateOrderApiModel {
}


